// extracted by mini-css-extract-plugin
module.exports = {"customWrapper":"TeamsComponent_customWrapper__1wvio"};